import { faCopy } from "@fortawesome/pro-duotone-svg-icons";
import { isAdmin as isAdminSignal, userData } from "../Common/Store/CommonSignals";
import ColorChangingIcon from "../Common/UI/ColorChangingIcon";
import { userBelongsToUserGroup } from "../Utilities/AuthorizationUtil";

function CloneButton({ onClick, data, name }) {
  const userIsAdmin = isAdminSignal.value;
  const userEmail = userData.value?.userEmail;

  const userIsCoOwnerViaUserGroup = data?.coOwners?.some(
    (co) => co.isUserGroup && co.userGroupId && userBelongsToUserGroup(userEmail, co.userGroupId)
  );

  const userHasModifyPermissionViaUserGroup = data?.sharedPermission?.some(
    (sp) =>
      sp.isUserGroup &&
      sp.userGroupId &&
      sp.permission === "Modify" &&
      userBelongsToUserGroup(userEmail, sp.userGroupId)
  );

  return (
    <ColorChangingIcon
      title="Clone Template"
      icon={faCopy}
      name={name}
      initialPrimaryColor="#00aeef"
      initialSize={18}
      hoverSize={18}
      hidden={
        !userIsAdmin &&
        data?.owner.toLowerCase() !== userEmail.toLowerCase() &&
        !data?.coOwners?.some((co) => co.user.toLowerCase() === userEmail.toLowerCase()) &&
        !userIsCoOwnerViaUserGroup &&
        !data?.sharedPermission?.some(
          (sp) => sp.entity.toLowerCase() === userEmail.toLowerCase() && sp.permission === "Modify"
        ) &&
        !userHasModifyPermissionViaUserGroup
      }
      onClick={onClick}
    />
  );
}

export default CloneButton;
